// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1778231411764
      var cssReload = require("../node_modules/@umijs/preset-umi/node_modules/@umijs/bundler-webpack/compiled/mini-css-extract-plugin/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","emit":true,"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  